import Typography from '@mui/material/Typography';
//import Grid from '@mui/material/Grid';
//import TextCenter from "../../../components/TextComps/TextCenter";



export default function LongevityTextInfo() {
  
  return (
<div>
    
    <Typography variant="h6" >
     <br /><br />
    <Typography component="span" variant="h6" sx={{fontWeight: '700'}}>FOXO3 variants associated with longevity</Typography>
    <br /><br />
    
    Scientific literature cites the following variants associated with longevity (in brackets: Longevity Allele): <br /><br />

    'rs6911407' (A), <br />
    'rs9486902'(T), <br />
    'rs2253310' (C),<br />
    'rs2802288'(A),<br />
    'rs12206094' (T),<br />
    'rs2802292' (G),<br />
    'rs13220810' (C), <br />
    'rs2764264' (C),<br />
    'rs7762395' (A),<br />
    'rs10457180' (G),<br />
    'rs13217795' (C),<br />
    'rs9400239' (T),<br />
    'rs3800231' (A),<br />
    'rs1935949' (T),<br />
    'rs4946935' (A),<br />
    'rs4946936' (T),<br />
    'rs479744' (T) <br /><br />

    The more longevity alleles are found in your gene FOXO3 the more advantagous and potentially contribution to longevity. <br /><br />

    <Typography component="span" variant="h6" sx={{fontWeight: '700'}}>Actionability: What can you do?</Typography>
    <br /><br />

 
  Lifestyle interventions: Promote intermittent fasting, caloric restriction, and physical activity, which upregulate FOXO3 activity. <br />
  Supplements: Consider antioxidants like resveratrol or spermidine that enhance FOXO pathways. <br />
  Monitoring: Biomarker tracking for oxidative stress and inflammation. <br /><br /><br />


Source: 
<Typography component="span" variant="body1" sx={{fontWeight: '200'}}>
    <br /><br />
https://pmc.ncbi.nlm.nih.gov/articles/PMC6175020/ (cited in Longevity / Sinclair)<br />
https://www.nature.com/articles/s41467-017-02183-y#change-history <br />
https://www.pnas.org/doi/full/10.1073/pnas.0809594106<br />
https://genomics.senescence.info/longevity/gene.php?id=FOXO3 <br />
</Typography>

    </Typography>
</div>
)}